<ng-container *transloco="let t; read: 'reports'">
<div mat-dialog-content class="rounded-lg  modal-body">
  <div class="flex justify-between border-b">
    <h1 class="text-[25px] font-bold">{{ t('viewChildren.title', { classroom: classroomName ?? t('viewChildren.classroomNotFound') }) }}</h1>
    <i
      mat-button
      mat-dialog-close
      class="text-drdpblue-300 cursor-pointer uil uil-times-circle"
    ></i>
  </div>
  <div class="w-full">
    <drdp-add-edit-table [dataSource]="dataSource" [tableData]="tableData"
      [columns]="tableColumns" (iconActionItem)="onIconClick($event)">
    </drdp-add-edit-table>
  </div>
  <mat-paginator class="mb-12" [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize" [length]="totalData" [pageIndex]="pageIndex"
    (page)="paginate(false)">
  </mat-paginator>
  <div mat-dialog-actions class="flex justify-end align-bottom">
    <div class="flex justify-end align-bottom">
      <drdp-btn color="cancel" class="mr-2" mat-dialog-close>{{ 'common.cancel' | transloco }}</drdp-btn>
    </div>
  </div>
</div>
</ng-container>
